import React, { FunctionComponent } from 'react';

import { DEFAULT_GRID_COLSPAN_SIZE, GridColSpanSize, GridOffsetPull, GridOffsetPush } from './Grid.constants';

export type GridOffsetType = {
  sm?: GridOffsetPull | GridOffsetPush;
  xs?: GridOffsetPull | GridOffsetPush;
  md?: GridOffsetPull | GridOffsetPush;
  lg?: GridOffsetPull | GridOffsetPush;
  xl?: GridOffsetPull | GridOffsetPush;
};

type GridProps = {
  bleed?: boolean;
  className?: string;
  compact?: boolean;
  container?: boolean;
  item?: boolean;
  xs?: boolean | GridColSpanSize;
  sm?: boolean | GridColSpanSize;
  md?: boolean | GridColSpanSize;
  lg?: boolean | GridColSpanSize;
  xl?: boolean | GridColSpanSize;
  offset?: GridOffsetType;
};

const Grid: FunctionComponent<GridProps> = ({
  bleed = false,
  className,
  compact = false,
  container = false,
  item = false,
  xs = DEFAULT_GRID_COLSPAN_SIZE,
  sm = false,
  md = false,
  lg = false,
  xl = false,
  offset,
  children,
}) => {
  const gridClasses = [];
  let content = <div data-testid="grid">children</div>;

  if (className) {
    gridClasses.push(className);
  }

  if (container) {
    gridClasses.push('o-grid-container');
    const rowClasses = ['o-grid-row'];

    if (bleed) {
      gridClasses.push('o-grid-container--bleed');
    }

    if (compact) {
      rowClasses.push('o-grid-row--compact');
    }

    content = (
      <div className={gridClasses.join(' ')} data-testid="grid">
        <div className={rowClasses.join(' ')} data-testid="gridRow">
          {children}
        </div>
      </div>
    );
  } else if (item) {
    const colspan = {
      xs: typeof xs === 'number' ? xs : DEFAULT_GRID_COLSPAN_SIZE,
      sm: typeof sm === 'number' ? `${offset?.sm ? `S${sm} S${offset.sm}` : `S${sm}`}` : false,
      md: typeof md === 'number' ? `${offset?.md ? `M${md} M${offset.md}` : `M${md}`}` : false,
      lg: typeof lg === 'number' ? `${offset?.lg ? `L${lg} L${offset.lg}` : `L${lg}`}` : false,
      xl: typeof xl === 'number' ? `${offset?.xl ? `XL${xl} XL${offset.xl}` : `XL${xl}`}` : false,
    };

    content = (
      <div
        className={gridClasses.join(' ')}
        data-testid="grid"
        data-o-grid-colspan={Object.values(colspan)
          .filter((colValue) => !!colValue)
          .join(' ')}
      >
        {children}
      </div>
    );
  }

  return content;
};

export default Grid;
